import React, { useEffect, useState } from "react";

export default function Gallery({ images }) {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const closeImage = () => {
    setSelectedIndex(null);
  };

  const showPreviousImage = (event) => {
    event.stopPropagation();

    setSelectedIndex((previousIndex) =>
      previousIndex === 0
        ? images.length - 1
        : previousIndex - 1
    );
  };

  const showNextImage = (event) => {
    event.stopPropagation();

    setSelectedIndex((previousIndex) =>
      previousIndex === images.length - 1
        ? 0
        : previousIndex + 1
    );
  };

  useEffect(() => {
    if (selectedIndex === null) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeImage();
      }

      if (event.key === "ArrowLeft") {
        setSelectedIndex((previousIndex) =>
          previousIndex === 0
            ? images.length - 1
            : previousIndex - 1
        );
      }

      if (event.key === "ArrowRight") {
        setSelectedIndex((previousIndex) =>
          previousIndex === images.length - 1
            ? 0
            : previousIndex + 1
        );
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedIndex, images.length]);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <>
      <section className="bilder-card">
        <h2>Galleri</h2>

        <div className="gallery-grid">
          {images.map((image, index) => (
            <img
              key={
                image.asset_id ||
                image.public_id ||
                image.secure_url
              }
              src={image.secure_url}
              alt={`Uppladdat bröllopsfoto ${index + 1}`}
              loading="lazy"
              onClick={() => setSelectedIndex(index)}
            />
          ))}
        </div>
      </section>

      {selectedIndex !== null && (
        <div
          className="gallery-lightbox"
          onClick={closeImage}
        >
          <button
            type="button"
            className="lightbox-close"
            onClick={closeImage}
            aria-label="Stäng bilden"
          >
            ×
          </button>

          {images.length > 1 && (
            <button
              type="button"
              className="lightbox-arrow lightbox-arrow-left"
              onClick={showPreviousImage}
              aria-label="Föregående bild"
            >
              ‹
            </button>
          )}

          <img
            src={images[selectedIndex].secure_url}
            alt={`Bröllopsbild ${selectedIndex + 1}`}
            onClick={(event) => event.stopPropagation()}
          />

          {images.length > 1 && (
            <button
              type="button"
              className="lightbox-arrow lightbox-arrow-right"
              onClick={showNextImage}
              aria-label="Nästa bild"
            >
              ›
            </button>
          )}
        </div>
      )}
    </>
  );
}